var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.998,
    height: 39.878,
    rx: 19.939,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 10C14.477 10 10 14.477 10 19.999C10 24.989 13.656 29.125 18.437 29.878V22.89H15.897V19.999H18.437V17.796C18.437 15.288 19.93 13.905 22.213 13.905C23.307 13.905 24.453 14.1 24.453 14.1V16.559H23.189C21.949 16.559 21.561 17.331 21.561 18.122V19.997H24.332L23.889 22.888H21.561V29.876C26.342 29.127 29.998 24.99 29.998 19.999C29.998 14.477 25.521 10 19.999 10Z",
    fill: "url(#paint0_linear_5611_41975)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5611_41975",
    x1: 10,
    y1: 19.939,
    x2: 29.998,
    y2: 19.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.517c042876b3f76cb33401f0741c60c2.svg";
export { ForwardRef as ReactComponent };